// Build ids are UTC ISO timestamps (see `vite.config.ts`), so plain string comparison
// doubles as chronological comparison — no need to parse them as dates.
export const isBuildOutdated = (buildId: string, minSupportedBuildId: string): boolean =>
  buildId < minSupportedBuildId
